<template>
    <div id="app">
      <div class="main-container">
        <router-view />
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'App',

  }
  </script>

  <style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    color: #2c3e50;
  }
  .main-container {
    height: 100%;
    margin: 0;
  }
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow-x: hidden;
  }


  </style>
